import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class ExpirationService extends ApiService {
  constructor(private http: Http) {
    super('api/expiration-ships/', http);
  }

  getExpirationsAssociaion() {
    const url = `${this.apiUrl}api/expirations-assocciation`;
    return this.http
      .get(url, { headers: this.getHeaders() })
      .map((res: any) => this.extractData(res))
      .catch((e) => this.handleError(e));
  }

  getExpirationsShip(shipId: number) {
    const url = `${this.apiUrl}api/expirations-ship/${shipId}`;
    return this.http
      .get(url, { headers: this.getHeaders() })
      .map((res: any) => this.extractData(res))
      .catch((e) => this.handleError(e));
  }

  getExpirationsNumber() {
    const url = `${this.apiUrl}api/expirations-association-number`;
    return this.http
      .get(url, { headers: this.getHeaders() })
      .map((res: any) => this.extractData(res))
      .catch((e) => this.handleError(e));
  }

  updateExpirations(body: any) {
    const url = `${this.apiUrl}api/update-expirations/`;
    return this.http
      .post(url, body, { headers: this.getHeaders() })
      .map((res: any) => this.extractData(res))
      .catch((e) => this.handleError(e));
  }

  deleteExpiration(id: any) {
    const url = `${this.apiUrl}api/update-expirations/`;
    const deleteUrl = `${url}?expiration_id=${id}`;

    return this.http
      .delete(deleteUrl, { headers: this.getHeaders() })
      .map((res: any) => this.extractData(res))
      .catch((e) => this.handleError(e));
  }

  getExpirationsTypes() {
    const url = `${this.apiUrl}api/expirations-types/`;
    return this.http
      .get(url, { headers: this.getHeaders() })
      .map((res: any) => this.extractData(res))
      .catch((e) => this.handleError(e));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/expiration.service.ts